import { useCallback, useRef, useState } from "react";

export default function useModal(value=false) {
	const [show, setShow] = useState(value);
	const ref = useRef();
	const open = useCallback(() => setShow(true), [ref]);
	const close = useCallback(() => setShow(false), [ref]);
	return { show, ref, open, close }
}